import { QUERY_KEYS } from "@/libraries/constant";
import { isAuthenticating } from "@/libraries/helper";
import { hemiService } from "@/services";
import type { CreateMessageResponse, ResError } from "@/types";
import {
	type UnusedSkipTokenOptions,
	queryOptions,
} from "@tanstack/react-query";

export const getHemiMessagesOptions = () =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_HEMI_MESSAGES],
		queryFn: () => hemiService.get(),
		enabled: isAuthenticating(),
	});

export const getHemiMessageResponseOptions = (
	uid: string,
	options?: Omit<
		UnusedSkipTokenOptions<CreateMessageResponse, ResError, any, string[]>,
		"queryKey" | "queryFn"
	>,
) =>
	queryOptions({
		queryKey: [QUERY_KEYS.GET_HEMI_RESPONSE_MESSAGE, uid],
		queryFn: ({ signal }) => hemiService.response(uid, signal),
		enabled: !!uid,
		...options,
	});
